import ImportContactsIcon from "@material-ui/icons/ImportContacts";
import * as React from "react";
import { cloneElement } from "react";
import { sanitizeListRestProps, TopToolbar } from "react-admin";
import CreateButton from "../components/buttons/CreateButton";

const Actions = ({
	currentSort,
	className,
	resource,
	filters,
	displayedFilters,
	exporter, // you can hide ExportButton if exporter = (null || false)
	filterValues,
	permanentFilter,
	hasCreate, // you can hide CreateButton if hasCreate = false
	basePath,
	selectedIds,
	onUnselectItems,
	showFilter,
	maxResults,
	total,
	...rest
}) => (
	<TopToolbar className={className} {...sanitizeListRestProps(rest)}>
		{filters &&
			cloneElement(filters, {
				resource,
				showFilter,
				displayedFilters,
				filterValues,
				context: "button",
			})}
		<CreateButton
			icon={<ImportContactsIcon />}
			label="resources.bookmaker-imports.create"
			basePath={basePath}
			baseRecord={filterValues}
		/>
	</TopToolbar>
);

Actions.defaultProps = {
	selectedIds: [],
	onUnselectItems: () => null,
};

export default Actions;
